import { itemFields } from "../Sku/itemField";
import { useEffect, useState } from "react";
import { toast } from "../../../components/AppToast";
import { useSelector } from "react-redux";
import { getCategoryAPI, getID } from "../../../services/skuItem/skuItem";
import { getLocationList } from "../../../services/location/location";
export default function CreateSKU({
  initialValues,
  onSubmit,
  onCancel,
  viewOnly,
  isEdit,
}) {
  const { userDetail } = useSelector((state) => state.login);

  const [category, setCategoryList] = useState([]);
  const [subCategory, setSubCategoryList] = useState([]);
  const [attribute, setAttributeList] = useState([]);
  const [attributeData, setAtrributeDataList] = useState({});

  const [locations, setLocations] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);
  const [open, setOpen] = useState(false);

  const [formData, setFormData] = useState({
    itemCode: "",
    itemName: "",
    itemDescription: "",
    brand: "",
    category: "",
    subCategory: "",
    attributes: {},
    gtin: "",
    uom: "",
    condition: "New",
    dimension: "",
    weight: "",
    reorderPoint: "",
    status: "Active",
    returnable: '',
    exchange: '',
    fulfillmentFrom: [],
    packagingInstructions: '',
    createdBy: "",
    updatedBy: "",
    updatedDate: "",
    images: [],
    length: '',
    width: '',
    height: ''
  });

  /* ---------------- HANDLE CHANGE ---------------- */

  const LIMIT = 20;
  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop <=
      e.target.clientHeight + 2;

    if (bottom) {
      fetchLocations(page + 1);
    }
  };


  useEffect(() => {
    if (open && locations.length === 0) {
      fetchLocations(0);
    }
  }, [open]);

  const fetchLocations = async (pageNo) => {
    if (loading || !hasMore) return;

    setLoading(true);
    const res = await getLocationList(pageNo, LIMIT);
    const list = res?.data || [];

    setLocations(prev => [...prev, ...list]);
    setHasMore(list.length === LIMIT);
    setPage(pageNo);

    setLoading(false);
  };


  const toggleLocation = (loc) => {
    setFormData((prev) => {
      const exists = prev.fulfillmentFrom.find(
        (l) => l._id === loc._id
      );

      return {
        ...prev,
        fulfillmentFrom: exists
          ? prev.fulfillmentFrom.filter((l) => l._id !== loc._id) // remove
          : [...prev.fulfillmentFrom, loc], // add
      };
    });
  };


  const handleChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };



  const handleCategoryChange = async (name, value) => {
    setFormData((prev) => ({
      ...prev,
      [name]: value,
      subCategory: "",
    }));

    setAttributeList([]);
    setAtrributeDataList({});

    const subCategoryFind =
      category.find((c) => c.categoryCode === value)?.subCategories || [];

    setSubCategoryList(subCategoryFind);

  };

  const handleSubCategoryChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));

    const attributesFind =
      subCategory.find((s) => s.subCategoryCode === value)?.attributes || [];

    setAttributeList(attributesFind);

  };

  const handleAttributeChange = (name, value) => {
    setAtrributeDataList((prev) => ({ ...prev, [name]: value }));
  };

  const handleDocChange = (file, name) => {
    setFormData((prev) => ({
      ...prev,
      'images': file,
    }));
  };

  /* ---------------- SUBMIT ---------------- */

  const submit = async (e) => {
    e.preventDefault();

    let newFormArray = formData.fulfillmentFrom.reduce((acc, num) => {
      acc.push(num._id);
      return acc;
    }, []
    );


    try {
      const finalData = {
        ...formData,
        attributes: attributeData,
        fulfillmentFrom: newFormArray,
        dimension: formData.length + '*' + formData.width + '*' + formData.height
      };

      if (isEdit) {
        try {
          await onSubmit(finalData, initialValues._id);
          toast.success('item updated successfully')
        }
        catch (err) {
          toast.error(err)
        }
      } else {
        try {
          await onSubmit(finalData);
          toast.success('item created successfully')
        }
        catch (err) {
          toast.error(err)
        }
      }


    } catch (err) {
      toast.error("Error saving item");
    }
  };

  /* ---------------- EDIT / VIEW MODE ---------------- */


  useEffect(() => {
    if (category && category.length != 0) {
      const subCategoryFind =
        category.find((c) => c.categoryCode === initialValues.category)?.subCategories || [];
      setSubCategoryList(subCategoryFind);
    }
  }, [isEdit, category, initialValues])


  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      subCategory: initialValues.subCategory
    }))
    const attributesFind =
      subCategory.find((s) => s.subCategoryCode === initialValues.subCategory)?.attributes || [];
    setAttributeList(attributesFind);
    setAtrributeDataList(initialValues.attributes || {})

  }, [isEdit, subCategory, initialValues]);



  useEffect(() => {
    if ((viewOnly || isEdit) && initialValues) {
      // console.log(initialValues, "initialValuesssssssssssssssssssss");

      let splitData = initialValues.dimension.split('*');
      fetchLocations(0);

      initialValues.locationId.map(p => {
        return toggleLocation(p)
      }
      )
      setFormData((prev) => ({
        ...prev,
        length: splitData[0],
        width: splitData[1],
        height: splitData[2],
        itemCode: initialValues.itemCode,
        itemName: initialValues.itemName,
        itemDescription: initialValues.itemDescription,
        brand: initialValues.brand,
        category: initialValues.category,
        condition: initialValues.condition,
        exchange: initialValues.exchange,
        gtin: initialValues.gtin,
        fulfillmentFrom: initialValues.locationId,
        reorderPoint: initialValues.reorderPoint,
        returnable: initialValues.returnable,
        status: initialValues.status,
        uom: initialValues.uom,
        weight: initialValues.weight,
        packagingInstructions: initialValues.packagingInstructions
      }))


    }

    if (isEdit) {
      setFormData((prev) => ({
        ...prev,
        updatedBy: userDetail?.email,
        updatedDate: new Date(),
      }));
    }
  }, [viewOnly, isEdit, initialValues, userDetail]);

  /* ---------------- CREATE MODE ---------------- */

  useEffect(() => {
    if (!viewOnly && !isEdit) {
      getIDd();
      setFormData((prev) => ({
        ...prev,
        createdBy: userDetail?.email,
      }));
    }
  }, []);

  /* ---------------- API CALLS ---------------- */

  const getCat = async () => {
    try {
      const res = await getCategoryAPI();
      if (res?.length) setCategoryList(res);
    } catch (err) {
      console.error(err);
    }
  };

  const getIDd = async () => {
    try {
      const res = await getID();
      setFormData((prev) => ({ ...prev, itemCode: res.sequence }));
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getCat();
  }, []);

  /* ---------------- RENDER ---------------- */

  return (
    <form onSubmit={submit}>
      <div className="d-flex flex-wrap gap-3">

        {/* ---------- STATIC FIELDS ---------- */}
        {itemFields.map((field) => {
          const isImage = field.type === "images";

          return (
            <div
              key={field.name}
              className="mb-2"
              style={{
                flex: isImage
                  ? "0 0 100%"
                  : `0 0 ${field.width || "15%"}`
              }}
            >
              <label className="form-label fw-semibold small">
                {field.label}
                {field.required && <span className="text-danger"> *</span>}
              </label>

              {field.type === "select" ? (
                <select
                  className="form-select form-select-sm"
                  value={formData[field.name] || ""}
                  onChange={(e) =>
                    handleChange(field.name, e.target.value)
                  }
                  disabled={viewOnly}
                >
                  <option value="">Select</option>
                  {field.name !== 'weight' && (field.options?.map((opt) => (
                    <option key={opt} value={opt}>{opt}</option>
                  )))}

                  {field.name == 'weight' && (field.fields?.map((opt) => (
                    <option key={opt.name} value={opt.name}>{opt.label}</option>
                  )))}
                </select>

              ) : field.type === "selectCategory" ? (
                <select
                  className="form-select form-select-sm"
                  value={formData.category}
                  onChange={(e) =>
                    handleCategoryChange(field.name, e.target.value)
                  }
                  disabled={viewOnly}
                >
                  <option value="">Select</option>
                  {category.map((c) => (
                    <option key={c.categoryCode} value={c.categoryCode}>
                      {c.categoryName}
                    </option>
                  ))}
                </select>

              ) : field.type === "selectSubCategory" ? (
                <select
                  className="form-select form-select-sm"
                  value={formData.subCategory}
                  onChange={(e) =>
                    handleSubCategoryChange(field.name, e.target.value)
                  }
                  disabled={viewOnly}
                >
                  <option value="">Select</option>
                  {subCategory.map((s) => (
                    <option
                      key={s.subCategoryCode}
                      value={s.subCategoryCode}
                    >
                      {s.subCategoryName}
                    </option>
                  ))}
                </select>

              ) : field.type === "images" ? (
                <input
                  type="file"
                  style={{ width: '45%' }}
                  className="form-control form-control-sm"
                  multiple
                  onChange={(e) =>
                    handleDocChange(Array.from(e.target.files), field.name)
                  }
                  disabled={viewOnly}
                />


              ) : field.type === "dimension" ? (
                <div className="d-flex align-items-center gap-1">
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    style={{ width: "50px" }}
                    value={formData.length || ""}
                    onChange={(e) => handleChange('length', e.target.value)}
                    readOnly={viewOnly}
                  />
                  <span>*</span>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    style={{ width: "50px" }}
                    value={formData.width || ""}
                    onChange={(e) => handleChange('width', e.target.value)}
                    readOnly={viewOnly}
                  />
                  <span>*</span>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    style={{ width: "50px" }}
                    value={formData.height || ""}
                    onChange={(e) => handleChange('height', e.target.value)}
                    readOnly={viewOnly}
                  />
                </div>
              ) : field.type === "multiselect" ? (
                <div style={{ width: 300, position: "relative" }}>
                  {/* SELECT BOX */}
                  <div
                    className="form-control form-control-sm"
                    onClick={() => setOpen(!open)}
                    style={{
                      cursor: "pointer",
                      minHeight: 31,
                      display: "flex",
                      flexWrap: "wrap",
                      gap: 6,
                    }}
                  >
                    {formData.fulfillmentFrom.length > 0 ? (
                      formData.fulfillmentFrom.map((loc) => (
                        <span
                          key={loc._id}
                          style={{
                            background: "#e9ecef",
                            padding: "2px 6px",
                            borderRadius: 4,
                            fontSize: 12,
                          }}
                        >
                          {loc.locationName}
                        </span>
                      ))
                    ) : (
                      <span style={{ color: "#999" }}>Select location</span>
                    )}
                  </div>

                  {/* DROPDOWN */}
                  {open && (
                    <div
                      onScroll={handleScroll}
                      style={{
                        position: "absolute",
                        width: "100%",
                        maxHeight: 240,
                        overflowY: "auto",
                        border: "1px solid #ccc",
                        background: "#fff",
                        zIndex: 10,
                      }}
                    >
                      {locations.map((loc) => {
                        const selected = formData.fulfillmentFrom.some(
                          (l) => l._id === loc._id
                        );

                        return (
                          <div
                            key={loc._id}
                            onClick={() => toggleLocation(loc)}
                            style={{
                              padding: 8,
                              cursor: "pointer",
                              background: selected ? "#f0f0f0" : "#fff",
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <span>{loc.locationName}</span>
                            {selected && <span>✔</span>}
                          </div>
                        );
                      })}

                      {loading && (
                        <div style={{ padding: 8, textAlign: "center" }}>
                          Loading...
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <input
                  type={field.type || "text"}
                  className="form-control form-control-sm"
                  value={formData[field.name] || ""}
                  onChange={(e) =>
                    handleChange(field.name, e.target.value)
                  }
                  readOnly={viewOnly || field.readonly}
                />
              )}
            </div>
          );
        })}

        {/* ---------- DYNAMIC ATTRIBUTES ---------- */}
        {attribute.map((attr) => (
          <div key={attr.name} className="mb-1" style={{ flex: "0 0 15%" }}>
            <label className="form-label fw-semibold small">{attr.name}</label>

            {(attr.type === "string" || attr.type === "number") && (
              <input
                type="text"
                className="form-control form-control-sm"
                value={attributeData[attr.name] || ""}
                onChange={(e) =>
                  handleAttributeChange(attr.name, e.target.value)
                }
                disabled={viewOnly}
              />
            )}

            {attr.type === "enum" && (
              <select
                className="form-select form-select-sm"
                value={attributeData[attr.name] || ""}
                onChange={(e) =>
                  handleAttributeChange(attr.name, e.target.value)
                }
                disabled={viewOnly}
              >
                <option value="">Select</option>
                {attr.values.map((v) => (
                  <option key={v} value={v}>{v}</option>
                ))}
              </select>
            )}

            {attr.type === "boolean" && (
              <select
                className="form-select form-select-sm"
                value={attributeData[attr.name] || ""}
                onChange={(e) =>
                  handleAttributeChange(attr.name, e.target.value)
                }
                disabled={viewOnly}
              >
                <option value="">Select</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            )}
          </div>
        ))}
      </div>

      {/* ---------- ACTION BUTTONS ---------- */}
      <div className="d-flex justify-content-center gap-2 mt-3">
        <button type="button" className="btn btn-secondary" onClick={onCancel}>
          Back
        </button>

        {!viewOnly && (
          <button type="submit" className="btn btn-primary">
            {isEdit ? "Update" : "Save"}
          </button>
        )}
      </div>
    </form>
  );
}
